import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useInAppLeaveGuard } from './useInAppLeaveGuard';

export interface UnsavedChangesGuardProps {
    when: boolean;
}

/** Lets the browser ask before a reload or close, and asks before an in-app navigation. */
function UnsavedChangesGuard({ when }: UnsavedChangesGuardProps) {
    const { t } = useTranslation();

    useEffect(() => {
        if (!when) return;
        function warn(event: BeforeUnloadEvent): void {
            event.preventDefault();
            // Older browsers ask only when returnValue is set; they show their own text.
            event.returnValue = '';
        }
        window.addEventListener('beforeunload', warn);
        return () => window.removeEventListener('beforeunload', warn);
    }, [when]);

    useInAppLeaveGuard(when, {
        title: t('providerConfig.unsaved.title'),
        message: t('providerConfig.unsaved.leave'),
        confirmLabel: t('providerConfig.unsaved.leaveAction'),
        confirmTone: 'danger',
    });

    return null;
}

export default UnsavedChangesGuard;
export { UnsavedChangesGuard };
